module.exports = __webpack_public_path__ + "static/media/blogBg.55e13aae.jpg";